
import LazyImg from '~/components/LazyImg/LazyImg.vue';
import type Brand from '~/type/Brand';
interface Props {
  /**
  * Объект бренда
  */
  brand: Brand;
  /**
  * Размер карточки
  */
  size: 's' | 'm';
  /**
  * Нужен ли лоад для изображения
  */
  photoLazyload: boolean;
}
const __sfc_main = {};
__sfc_main.props = {
  brand: {
    key: "brand",
    required: true,
    type: null
  },
  size: {
    key: "size",
    required: false,
    type: String,
    default: 's'
  },
  photoLazyload: {
    key: "photoLazyload",
    required: false,
    type: Boolean,
    default: true
  }
};
__sfc_main.setup = (__props, __ctx) => {
  return {};
};
__sfc_main.components = Object.assign({
  LazyImg
}, __sfc_main.components);
export default __sfc_main;
